// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"258b012d","455":"19769c0d","977":"3becd578"}[chunkId] + ".chunk.js";
};